module.exports = __webpack_public_path__ + "media/Tears in the Sand.42121560.mp3";